import * as util from '../apiUtils';
import * as common from '../apiCommon';
import { UNIT_OF_MEASURE_TYPE } from '../../constants/constant_doc_types';

export function fetchUnitOfMeasureTypeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'unit_of_measure_type/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
  };

  return common.getDropdownList(app, { query });
}

export function saveUnitOfMeasureType(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  const doc = {
    doc_type: UNIT_OF_MEASURE_TYPE,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
  };

  return common.saveDoc(app, {
    source: data,
    doc,
    user,
  });
}

export function deleteUnitOfMeasureType(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: UNIT_OF_MEASURE_TYPE,
  });
}

export function fetchUnitOfMeasureTypeById(app, params) {
  const { id } = params;
  const docType = UNIT_OF_MEASURE_TYPE;
  return common.getDoc(app, { id, docType });
}
